import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.5) transparent;


*::-webkit-scrollbar {
  width: 5px;
}
*::-webkit-scrollbar-track {
  background: rgba(37, 37, 37, 1);
}
*::-webkit-scrollbar-thumb {
  background-color: rgba(155, 155, 155, 0.5);
  border-radius: 20px;
  border: transparent;
}
}


html,body {
  max-width: 100%;

  background: #483A37;

  font-family: 'Anton', sans-serif;

@media (max-width: 1000px) {
  font-size: 60%;
}
}


ul {
  list-style: none;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
  
}

a:hover {
   text-shadow: 0 0 40px #1d1816;
}
p {
  max-width: 1000px;
}
`;
export default GlobalStyle;

//white F8F8F8
//bg 483A37
